import { createFileRoute } from '@tanstack/react-router'
import { SquadPage } from '~/features/people/SquadPage'
import { loaderScope, squadQuery } from '~/features/people/queries'

export const Route = createFileRoute('/_app/kader/')({
  loader: async ({ context }) => {
    const scope = await loaderScope(context.queryClient)
    if (scope?.teamId) await context.queryClient.ensureQueryData(squadQuery(scope.teamId, scope.season)).catch(() => undefined)
  },
  component: SquadPage,
})
